import React, { useEffect, useState } from 'react';
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import ProtectedRoute from '@utilities/ProtectedRoute';
import NavigationLoadingOverlay from '@utilities/NavigationLoadingOverlay';
import NotFound from '@flows/NotFound';
import { initializeFirebase } from '@utilities/auth';

import POSPanelPublic from '@flows/POSPanel/public';
import Login from '@flows/Onboarding/Login';
import Logout from '@flows/Onboarding/Logout';
import Dashboard from '@flows/Dashboard';
import Admin from '@flows/Admin';
import AdminOrders from '@flows/Admin/Orders';
import POS from '@flows/Admin/POS';
import POSV2 from '@flows/Admin/POSV2';
import Header from '@flows/Header';
import BottomNav from '@src/flows/BottomNav';
import Report from '@flows/Admin/Report';
import Analytics from '@flows/Admin/Report/Analytics';
import RoomBooking from '@flows/Admin/RoomBooking';
import RoomBookingUser from '@flows/Admin/RoomBooking/RoomBookingUser';
import TableBooking from '@flows/Admin/TableBooking';
import TableBookingUser from '@flows/Admin/TableBooking/TableBookingUser';
import ExpensesTracker from '@flows/Admin/ExpensesTracker';
import Inventory from '@flows/Admin/Inventory';
import RoomBilling from '@src/flows/Admin/Orders/RoomBilling';
import TwoColumn from '@layouts/TwoColumn';
import CustomizedSnackbars from '@components/CustomizedSnackbars';
import Profile from '@flows/Onboarding/Profile';
import {runOncePerDevice, migrateOldCartData} from '@utilities/common';

import UpdateOrder from '@data/UpdateOrder';
import CreateRestaurant from '@data/CreateRestaurant';
import UpdateRestaurant from '@data/UpdateRestaurant';
import CreateUser from '@data/CreateUser';
import { connect } from 'react-redux';
import {hasPermission} from '@utilities/common';
import About from '@flows/Onboarding/About';
import Terms from '@flows/Onboarding/Terms';
import Privacy from '@flows/Onboarding/Privacy';
import FooterInfo from '@components/FooterInfo';
import OnlineOrders from '@flows/Admin/OnlineOrders';
import KotLoggingReport from '@flows/Admin/KotLogging';
import OrderLoggingReport from '@flows/Admin/OrderLogging';
import { NotificationProvider, NotificationToastStack } from '@notifications';

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './App.scss';
// import UploadOrdersData from './data/Upload orders';

const App = ({logs, selectedRestaurant, selectedRestId, roles, isSuperAdmin, userPermissions}: any) => {
    const [open, setOpen] = useState(false);
    initializeFirebase();

    const canReadReport = hasPermission(userPermissions, "reports", "read");
    const canReadAnalytics = hasPermission(userPermissions, "analytics", "read");
    const canRoomBookings = hasPermission(userPermissions, "roomBookings", "write");


    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per device using env, selectedRestaurant intentionally excluded to avoid re-run on change
    useEffect(() => {
        runOncePerDevice(
          process.env.REACT_APP_FORCE_ACTIONS || '',
          () => {
            console.log('Migrating cart data for the first time on this device.');
            selectedRestaurant && migrateOldCartData(selectedRestaurant);
          }
        );
      // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per device
      }, [process.env.REACT_APP_FORCE_ACTIONS]);

    useEffect(() => {
        logs.length && setOpen(true);
    }, [logs]);

    const onClose = () => {
        setOpen(false);
    }

    return (
        <>
            <BrowserRouter>
                <NotificationProvider>
                <NavigationLoadingOverlay />
                <Routes>
                    <Route path="/" element={<><Header /><Dashboard /><FooterInfo /></>} />
                    <Route path="/about" element={<><Header /><About /><FooterInfo /></>} />
                    <Route path="/terms" element={<><Header /><Terms /><FooterInfo /></>} />
                    <Route path="/privacy" element={<><Header /><Privacy /><FooterInfo /></>} />
                    <Route path="/restaurant/:restaurantId" element={<><Header /><POSPanelPublic /></>} />
                    {/* <Route path="/orders" element={<ProtectedRoute><><Header /><Orders /><FooterInfo /></></ProtectedRoute>} /> */}
                    {/* <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} /> */}
                    {/* <Route path="/upload-order" element={<ProtectedRoute><UploadOrdersData /></ProtectedRoute>} /> */}
                    <Route path="/login" element={<><Header /><TwoColumn><Login /></TwoColumn><FooterInfo /></>} />
                    <Route path="/logout" element={<ProtectedRoute><Logout /></ProtectedRoute>} />
                    {/* <Route path="/profile" element={<ProtectedRoute><><Header /><TwoColumn><Profile /></TwoColumn><FooterInfo /></></ProtectedRoute>} /> */}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/profile" element={<ProtectedRoute><><Header /><Profile /><BottomNav key={`key-${12}`} active={12} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && <Route path="/admin" element={<ProtectedRoute><><Header /><Admin /><BottomNav key={`key-${0}`} active={0} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/orders" element={<ProtectedRoute><><Header /><AdminOrders /><BottomNav key={`key-${0}`} active={0} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/online-orders" element={<ProtectedRoute><><Header /><OnlineOrders /><BottomNav key={`key-${14}`} active={14} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/room-billing" element={<ProtectedRoute><><Header /><RoomBilling /><BottomNav key={`key-${1}`} active={1} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/pos" element={<ProtectedRoute><div className='posPage'><Header /><POS /><BottomNav key={`key-${2}`} active={2} /></div></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/pos-v2" element={<ProtectedRoute><div className='posPage'><Header /><POSV2 /><BottomNav key={`key-${2}`} active={2} /></div></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager', 'staff'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/khaata" element={<ProtectedRoute><><Header /><ExpensesTracker /><BottomNav key={`key-${3}`} active={3} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin', 'manager'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/inventory" element={<ProtectedRoute><><Header /><Inventory /><BottomNav key={`key-${4}`} active={4} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || canReadReport) && <Route path="/admin/:restaurantId/report" element={<ProtectedRoute><><Header /><Report /><BottomNav key={`key-${7}`} active={7} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || canReadAnalytics) && <Route path="/admin/:restaurantId/analytics" element={<ProtectedRoute><><Header /><Analytics /><BottomNav key={`key-${13}`} active={13} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && (['admin'].includes(roles[selectedRestId]?.role) || canRoomBookings) && <Route path="/admin/:restaurantId/room-booking" element={<ProtectedRoute><><Header /><RoomBooking /><BottomNav key={`key-${9}`} active={9} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/table-booking" element={<ProtectedRoute><><Header /><TableBooking /><BottomNav key={`key-${8}`} active={8} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/table-booking/user" element={<ProtectedRoute><><Header /><TableBookingUser /><BottomNav key={`key-${10}`} active={10} /><FooterInfo /></></ProtectedRoute>} />}
                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/room-booking/user" element={<ProtectedRoute><><Header /><RoomBookingUser /><BottomNav key={`key-${11}`} active={11} /><FooterInfo /></></ProtectedRoute>} />}
                    {/* {roles && {['admin'].includes(roles[selectedRestId]?.role || '') && <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />} */}

                    {roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role) && <Route path="/admin/:restaurantId/order/:orderId" element={<ProtectedRoute><><Header /><TwoColumn><UpdateOrder /></TwoColumn><FooterInfo /></></ProtectedRoute>} />}
                    {isSuperAdmin && selectedRestId && <Route path="/admin/:restaurantId/kot-logging" element={<ProtectedRoute><><Header /><KotLoggingReport /><FooterInfo /></></ProtectedRoute>} />}
                    {isSuperAdmin && selectedRestId && <Route path="/admin/:restaurantId/order-logging" element={<ProtectedRoute><><Header /><OrderLoggingReport /><FooterInfo /></></ProtectedRoute>} />}
                    {isSuperAdmin && <Route path="/admin/create-restaurant" element={<ProtectedRoute><><Header /><TwoColumn><CreateRestaurant /></TwoColumn><FooterInfo /></></ProtectedRoute>} />}
                    {isSuperAdmin && <Route path="/admin/update-restaurant" element={<ProtectedRoute><><Header /><TwoColumn><UpdateRestaurant /></TwoColumn><FooterInfo /></></ProtectedRoute>} />}
                    {isSuperAdmin && <Route path="/admin/create-user" element={<ProtectedRoute><><Header /><TwoColumn><CreateUser /></TwoColumn><FooterInfo /></></ProtectedRoute>} />}
                    {/* {(isSuperAdmin || (roles && selectedRestId && ['admin'].includes(roles[selectedRestId]?.role))) && (
                        <Route
                            path="/admin/:restaurantId/backfill-order-seq"
                            element={
                                <ProtectedRoute>
                                    <>
                                        <Header />
                                        <TwoColumn>
                                            <BackfillOrderSeqNo />
                                        </TwoColumn>
                                        <FooterInfo />
                                    </>
                                </ProtectedRoute>
                            }
                        />
                    )} */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <NotificationToastStack />
                </NotificationProvider>
            </BrowserRouter>
            {logs[0]?.severity && <CustomizedSnackbars onClose={onClose} open={open} severity={logs[0]?.severity || "info"} message={logs[0]?.message || "Test"} />}
        </>
    );
}

const mapStateToProps = (state: any) => {
    const { logs, user, common } = state;
    return {
        logs: logs?.logs,
        selectedRestaurant: common?.selectedRestaurant,
        selectedRestId: common?.selectedRestaurant?.docId || "",
        roles: user?.user?.roles || {},
        userPermissions: user?.user?.roles ? {...common?.globalConfig?.permissions, ...(user?.user?.roles[common?.selectedRestaurant?.docId]?.permissions)} : {},
        isSuperAdmin: user?.user?.isSuperAdmin || false
    }
}

export default connect(mapStateToProps)(App)
